import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'pilcrow', 'Pilcrow', [["path",{"d":"M13 4v16"}],["path",{"d":"M17 4v16"}],["path",{"d":"M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5"}]]);